import { render, staticRenderFns } from "./CompleteForm.vue?vue&type=template&id=652525b4&scoped=true"
import script from "./CompleteForm.vue?vue&type=script&lang=js"
export * from "./CompleteForm.vue?vue&type=script&lang=js"
import style0 from "./CompleteForm.vue?vue&type=style&index=0&id=652525b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652525b4",
  null
  
)

export default component.exports